import React from 'react';
import { FileData } from 'API';
import { format as formatDate, parseISO } from 'date-fns';

interface Props {
  file?: FileData;
  withUploadDate?: boolean;
}

const FileName: React.FC<Props> = ({ file, withUploadDate }: Props) => {
  if (!file) {
    return null;
  }

  return (
    <>
      {file.fileName}
      {withUploadDate && file.uploadDate && ` — Uploaded on ${formatDate(
        parseISO(file.uploadDate),
        'M/d/yyyy',
      )}`}
    </>
  );
};

export default FileName;
